import { PreviewBlock } from "../../landing-components/PreviewSection";
import { ThreeBlocksSection } from "../../components/ThreeBlocksSection";
import { useTranslation } from "react-i18next";
import wr1 from "../../assets/images/Huis Hospi Housing stijl.webp";
import wr2 from "../../assets/images/Hospi Housing icoon pratende mensen.webp";
import wr3 from "../../assets/images/Hospi Housing huis met hartjes.webp";
import videoPreview2 from "../../assets/images/Student en gastgezin geven high five.webp";
import videoPreview1 from "../../assets/images/videoPreview1.webp";
import { VideoSection } from "../../components/VideoSection";
import { PrecededYouSection } from "../../components/PrecededYouSection";
import { FAQ } from "../../components/FAQ";
import { useLocation } from "react-router-dom";
import { PreferToBeCalledSection } from "./components/Form";
import { SignUpForFreeSection } from "./components/SignUpForFree";
import { HeaderSEO } from "../../components/headerSEO";
import { ISeo } from "../../interfaces/intarfaces";
import {
  wr_H_1,
  wr_H_2,
  wr_S_1,
  wr_S_2,
  wr_SH_3
} from "../../components/Icons/UserMainPage";

export const UserMainPage = () => {
  const { pathname } = useLocation();

  const pageKey = pathname.includes("hospita") ? "hostPage" : "studentPage";
  const translationFile = pathname.includes("hospita")
    ? "becomehost"
    : "findroom";

  const { t, i18n } = useTranslation(translationFile);
  const { t: seo_t } = useTranslation(translationFile);

  const sharedRegisterUrl = `/${i18n.language}/register?m=${pageKey === "hostPage" ? "h" : "s"
    }`;

  const seo = seo_t(
    `${pageKey === "hostPage" ? "becomepage" : "findpage"}.seo`,
    { returnObjects: true }
  ) as ISeo;

  const whyRentItems = [
    {
      title: t(`${pageKey}.whyRent.p1.title`),
      text: t(`${pageKey}.whyRent.p1.text`),
      src: pageKey === "hostPage" ? wr_H_1 : wr_S_1
    },
    {
      title: t(`${pageKey}.whyRent.p2.title`),
      text: t(`${pageKey}.whyRent.p2.text`),
      src: pageKey === "hostPage" ? wr_H_2 : wr_S_2
    },
    {
      title: t(`${pageKey}.whyRent.p3.title`),
      text: t(`${pageKey}.whyRent.p3.text`),
      src: wr_SH_3
    }
  ];
  const startHostingItems = [
    {
      title: t(`${pageKey}.startHosting.p1.title`),
      text: t(`${pageKey}.startHosting.p1.text`),
      src: wr1
    },
    {
      title: t(`${pageKey}.startHosting.p2.title`),
      text: t(`${pageKey}.startHosting.p2.text`),
      src: wr2
    },
    {
      title: t(`${pageKey}.startHosting.p3.title`),
      text: t(`${pageKey}.startHosting.p3.text`),
      src: wr3
    }
  ];

  const videoSectionList = [
    t(`${pageKey}.videoSection.list.p1`),
    t(`${pageKey}.videoSection.list.p2`),
    t(`${pageKey}.videoSection.list.p3`),
    t(`${pageKey}.videoSection.list.p4`),
    t(`${pageKey}.videoSection.list.p5`)
  ];

  return (
    <div style={{ background: "white" }}>
      {seo && <HeaderSEO {...seo} />}
      <PreviewBlock mode={pageKey} />
      <ThreeBlocksSection
        title={[
          t(`${pageKey}.whyRent.title.p1`),
          t(`${pageKey}.whyRent.title.p2`)
        ]}
        items={whyRentItems}
      />
      <VideoSection
        pageKey={pageKey}
        sharedRegisterUrl={sharedRegisterUrl}
        previewSrc={videoPreview1}
        title={t(`${pageKey}.videoSection.title1`)}
        text={t(`${pageKey}.videoSection.text`)}
        buttonText={t(`${pageKey}.videoSection.button`)}
      />
      <ThreeBlocksSection
        reverseColor
        title={[
          t(`${pageKey}.startHosting.title.p1`),
          t(`${pageKey}.startHosting.title.p2`)
        ]}
        items={startHostingItems}
      />
      <VideoSection
        pageKey={pageKey}
        sharedRegisterUrl={sharedRegisterUrl}
        previewSrc={videoPreview2}
        title={t(`${pageKey}.videoSection.title2`)}
        text={videoSectionList}
        buttonText={t(`${pageKey}.videoSection.becameHost`)}
        reverse
      />
      <PrecededYouSection />
      <FAQ />
      {pageKey === "hostPage" ? (
        <PreferToBeCalledSection />
      ) : (
        <SignUpForFreeSection />
      )}
      <div style={{ height: 64, background: "white" }} />
    </div>
  );
};
